import { Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { environment } from '../../environments/environment';

var HOST = environment.apiHost;

@Injectable()
export class ReleaseService {

  constructor(private http: Http) { }

  getReleaseData(param, data?: any): Promise<any> {

    const params: URLSearchParams = new URLSearchParams();
    params.set('fromdate', param.fd);
    params.set('todate', param.td);

    return this.http.post(HOST + '/release', params)
      .toPromise()
      .then(response => {
        return response.json();
      })
      .catch(err => err);

  }

}
